import React from 'react'
import * as Yup from 'yup'
import { UserRoleEnum } from 'generated/api'
import { regexNumber } from 'constants/regex'

export const validationInputZero = (val: string) => {
  const data = val.length > 1 && val[0] === '0' ? val.split('').splice(1, 1).join() : val
  return data
}

export const phoneInputValidation = (
  evt: React.KeyboardEvent<HTMLInputElement>,
  value: string,
  maxLength: number,
): void => {
  const key = evt.key
  const isNumber = /^(\d)*$/i.test(key)
  const allowedKey = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter']
  if (
    (value.length === 0 && key !== '0' && !evt.ctrlKey && allowedKey.indexOf(key) === -1) ||
    (value.length === 1 && key !== '8' && !evt.ctrlKey && allowedKey.indexOf(key) === -1)
  ) {
    evt.preventDefault()
  }
  if (value.length >= maxLength) {
    if (!evt.ctrlKey && allowedKey.indexOf(key) === -1) {
      evt.preventDefault()
    }
  } else {
    if (!evt.ctrlKey && !isNumber && allowedKey.indexOf(key) === -1) {
      evt.preventDefault()
    }
  }
}

export const pinInputValidation = (
  evt: React.KeyboardEvent<HTMLInputElement>,
  value: string,
  maxLength: number,
): void => {
  const key = evt.key
  const isNumber = /^(\d)*$/i.test(key)
  const allowedKey = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter']
  if (value.length >= maxLength) {
    if (allowedKey.indexOf(key) === -1) {
      evt.preventDefault()
    }
  } else {
    if (!isNumber && allowedKey.indexOf(key) === -1) {
      evt.preventDefault()
    }
  }
}

export const phonePasteValidation = (
  e: React.ClipboardEvent<HTMLInputElement>,
  currentVal: string,
  maxLength: number,
) => {
  const clipboardData = e.clipboardData
  const pastedData = clipboardData.getData('Text')
  const isNumeric = /^\d+$/.test(pastedData)
  const totalCharacters = currentVal.length + pastedData.length
  const firstTwoCharacters = pastedData.slice(0, 2)
  if (firstTwoCharacters !== '08' || !isNumeric || totalCharacters > maxLength) {
    e.preventDefault()
  }
}

export const validationPhoneNumber = (e: React.ChangeEvent<HTMLInputElement>): boolean => {
  const input = e.currentTarget.value

  const conditionLength = input.length > 13
  const conditionRegex = !regexNumber.test(input)
  const conditionStart =
    (input.length == 1 && !input.startsWith('0')) || (input.length >= 2 && !input.startsWith('08'))

  return !(conditionLength || conditionRegex || conditionStart)
}

export const validationSchemaFormProduct = Yup.object({
  sku: Yup.string().required('Mohon Isi Kode SKU Produk'),
  categoryId: Yup.string().required('Pilih Kategori Produk'),
  name: Yup.string().required('Mohon Isi Nama Produk'),
  unitOfMeasurement: Yup.string().required('Mohon pilih salah satu'),
  productWeight: Yup.number()
    .moreThan(0, 'Mohon isi berat satuan produk')
    .max(99999, 'Maksimal 5 digit')
    .required('Mohon isi berat satuan produk'),
  dimensionMeasurement: Yup.string().when(
    ['dimensionLength', 'dimensionWidth', 'dimensionHeight'],
    (dimensions: (number | undefined)[], schema: Yup.StringSchema) => {
      const [dimensionLength, dimensionWidth, dimensionHeight] = dimensions
      return (dimensionLength && dimensionLength > 0) ||
        (dimensionWidth && dimensionWidth > 0) ||
        (dimensionHeight && dimensionHeight > 0)
        ? schema.required('Mohon isi satuan dimensi produk')
        : schema
    },
  ),
  dimensionLength: Yup.number()
    .test('dimensionMeasurement', 'Mohon isi panjang produk', function (value) {
      const { dimensionMeasurement } = this.parent
      if (dimensionMeasurement) {
        return value !== undefined && value > 0
      }
      return true
    })
    .max(99999, 'Maksimal 5 digit'),
  dimensionWidth: Yup.number()
    .test('dimensionMeasurement', 'Mohon isi lebar produk', function (value) {
      const { dimensionMeasurement } = this.parent
      if (dimensionMeasurement) {
        return value !== undefined && value > 0
      }
      return true
    })
    .max(99999, 'Maksimal 5 digit'),
  dimensionHeight: Yup.number()
    .test('dimensionMeasurement', 'Mohon isi tinggi produk', function (value) {
      const { dimensionMeasurement } = this.parent
      if (dimensionMeasurement) {
        return value !== undefined && value > 0
      }
      return true
    })
    .max(99999, 'Maksimal 5 digit'),
  imageURL: Yup.string().required('Mohon upload foto produk'),
})

export const validationSchemaFormStockLocation = Yup.object({
  name: Yup.string().required('Mohon isi nama lokasi').max(100, 'Maksimal 100 Karakter'),
  ownerName: Yup.string().required('Mohon isi nama pemilik').max(100, 'Maksimal 100 Karakter'),
  ownerPhoneNo: Yup.string()
    .required('Mohon isi Nomor Telepon')
    .min(10, 'Nomor telepon minimal 10 Digit'),
  address: Yup.string().required('Mohon isi alamat lokasi').max(300, 'Maksimal 300 Karakter'),
  province: Yup.string().required('Mohon pilih Provinsi'),
  city: Yup.string().required('Mohon pilih Kota/Kabupaten'),
  invoiceCode: Yup.string().required('Mohon isi kode invoice').max(10, 'Maksimal 10 Karakter'),
  latitude: Yup.number()
    .min(-90, 'Latitude harus lebih dari atau sama dengan -90')
    .max(90, 'Latitude harus kurang dari atau sama dengan to 90')
    .required('Mohon isi latitude'),
  longitude: Yup.number()
    .min(-180, 'Longitude harus lebih dari atau sama dengan -180')
    .max(180, 'Longitude harus kurang dari atau sama dengan 180')
    .required('Longitude is required'),
  openHour: Yup.string().required('Mohon isi jam buka'),
  closeHour: Yup.string().required('Mohon isi jam tutup'),
})

export const validationSchemaFormVoucher = Yup.object({
  name: Yup.string()
    .required('Mohon Masukkan 3 - 25 Karakter')
    .min(3, 'Mohon Masukkan 3 - 25 Karakter')
    .max(25, 'Mohon Masukkan 3 - 25 Karakter'),
  label: Yup.string().required('Maksimal 25 Karakter').max(25, 'Maksimal 25 Karakter'),
  code: Yup.string().when(['type'], ([type], schema) =>
    type === 'PRIVATE'
      ? schema
          .required('Mohon masukkan 5 - 25 Karakter')
          .min(5, 'Mohon masukkan 5 - 25 Karakter')
          .max(25, 'Mohon masukkan 5 - 25 Karakter')
      : schema,
  ),
  description: Yup.string().required('Maksimal 500 Karakter').max(500, 'Maksimal 500 Karakter'),
  discountAmount: Yup.number().when(['discountType'], ([discountType], schema) => {
    if (discountType === 'PERCENTAGE') {
      return schema
        .required('Mohon masukkan 1 - 100')
        .min(1, 'Mohon masukkan 1 - 100')
        .max(100, 'Mohon masukkan 1 - 100')
    } else if (discountType === 'SAWITPOINPERCENTAGE') {
      return schema
        .required('Mohon masukkan 1 - 100')
        .min(1, 'Mohon masukkan 1 - 100')
        .max(100, 'Mohon masukkan 1 - 100')
    } else {
      return schema.required('Minimal 1.000').min(1000, 'Minimal 1.000')
    }
  }),
  startAtUtc0: Yup.number()
    .required('Mohon pilih tanggal mulai')
    .min(1, 'Mohon pilih tanggal mulai'),
  endAtUtc0: Yup.number()
    .required('Mohon pilih tanggal berakhir')
    .min(1, 'Mohon pilih tanggal berakhir'),
  appTypes: Yup.array().min(1, 'Mohon pilih salah satu atau semua'),
  userRoles: Yup.array().min(1, 'Mohon pilih salah satu atau semua'),
  maxRedemption: Yup.number().min(1, 'Mohon masukkan minimal 1'),
  maxRedemptionPerUser: Yup.number().min(1, 'Mohon masukkan minimal 1'),
  paymentMethods: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Mohon pilih salah satu atau keduanya'),
  imageUrl: Yup.string().required('Mohon upload foto voucher'),
})

export const validationSchemaFormStockPrice = Yup.object({
  productId: Yup.string().required('Mohon pilih produk'),
  startDateUtc0: Yup.number()
    .required('Mohon pilih tanggal mulai')
    .min(1, 'Mohon pilih tanggal mulai'),
  endDateUtc0: Yup.number()
    .required('Mohon pilih tanggal berakhir')
    .min(1, 'Mohon pilih tanggal berakhir'),
  stockAmount: Yup.number().required('Mohon isi jumlah stok').min(0, 'Mohon isi jumlah stok'),
  preparationDuration: Yup.number()
    .required('Mohon isi SLA per hari')
    .min(0, 'Mohon isi SLA per hari'),
  minimumOrder: Yup.number().required('Mohon isi minimal order').min(1, 'Mohon isi minimal order'),
  prices: Yup.array()
    .of(
      Yup.object().shape({
        minimumQuantity: Yup.number()
          .required('Mohon isi minimal kuantitas')
          .min(1, 'Mohon isi minimal kuantitas'),
        price: Yup.number().positive().required('Mohon isi harga').min(1, 'Mohon isi harga'),
      }),
    )
    .test('is-increasing-quantity', '', function (value) {
      const errors = []
      if (value) {
        for (let i = 0; i < value.length; i++) {
          if (i !== value.length - 1) {
            if (value[i].minimumQuantity >= value[i + 1].minimumQuantity) {
              errors.push(
                this.createError({
                  message: 'Masukkan angka yang lebih besar',
                  path: `${this.path}[${i + 1}].minimumQuantity`,
                }),
              )
            }
          }
        }
      }
      return errors.length > 0 ? new Yup.ValidationError(errors) : true
    })
    .test('price >= from previous price', '', function (value) {
      const errors = []
      if (value) {
        for (let i = 0; i < value.length; i++) {
          if (i !== value.length - 1) {
            if (value[i].price < value[i + 1].price) {
              errors.push(
                this.createError({
                  message: 'Harga lebih besar dari harga sebelumnya',
                  path: `${this.path}[${i + 1}].price`,
                }),
              )
            }
          }
        }
      }
      return errors.length > 0 ? new Yup.ValidationError(errors) : true
    }),
})

export const validationSchemaFormVendor = Yup.object({
  name: Yup.string()
    .required('Mohon isi nama vendor')
    .min(3, 'Mohon Masukkan 3-100 Karakter')
    .max(100, 'Mohon Masukkan 3-100 Karakter'),
  type: Yup.string().required('Mohon pilih tipe vendor'),
  ownerName: Yup.string()
    .required('Mohon isi nama pemilik')
    .min(3, 'Mohon Masukkan 3-100 Karakter')
    .max(100, 'Mohon Masukkan 3-100 Karakter'),
  ownerPhoneNo: Yup.string()
    .required('Masukkan nomor Telepon')
    .min(3, 'Mohon Masukkan 3-15 Karakter')
    .max(15, 'Mohon Masukkan 3-15 Karakter'),
  picName: Yup.string()
    .notRequired()
    .min(3, 'Mohon Masukkan 3-100 Karakter')
    .max(100, 'Mohon Masukkan 3-100 Karakter'),
  picPhoneNo: Yup.string()
    .notRequired()
    .min(10, 'Mohon Masukkan 10-13 Karakter')
    .max(13, 'Mohon Masukkan 10-13 Karakter'),
  taxIdentityNo: Yup.string()
    .notRequired()
    .min(16, 'Mohon Masukkan 16-20 Karakter')
    .max(20, 'Mohon Masukkan 16-20 Karakter'),
  province: Yup.string().required('Mohon pilih Provinsi'),
  city: Yup.string().required('Mohon pilih Kota/Kabupaten'),
  address: Yup.string()
    .required('Mohon isi alamat vendor')
    .min(3, 'Mohon Masukkan 3-256 Karakter')
    .max(256, 'Mohon Masukkan 3-256 Karakter'),
  latitude: Yup.number()
    .min(-90, 'Latitude harus lebih dari atau sama dengan -90')
    .max(90, 'Latitude harus kurang dari atau sama dengan to 90')
    .required('Mohon isi latitude'),
  longitude: Yup.number()
    .min(-180, 'Longitude harus lebih dari atau sama dengan -180')
    .max(180, 'Longitude harus kurang dari atau sama dengan 180')
    .required('Longitude is required'),
  bankId: Yup.string().required('Mohon pilih bank'),
  bankAccountNo: Yup.string().required('Mohon isi nomor rekening'),
  bankAccountName: Yup.string()
    .required('Mohon isi nama pemilik rekening')
    .min(3, 'Mohon Masukkan 3-100 Karakter')
    .max(100, 'Mohon Masukkan 3-100 Karakter'),
})

export const validationSchemaFormCategory = Yup.object({
  name: Yup.string()
    .required('Mohon isi nama kategori')
    .min(3, 'Mohon Masukkan 3-100 Karakter')
    .max(100, 'Mohon Masukkan 3-100 Karakter'),
  maxPointUsage: Yup.number().required('Mohon isi maksimal poin').min(0, 'Mohon isi maksimal poin'),
  rolePointUsageItems: Yup.array()
    .of(
      Yup.object().shape({
        role: Yup.string()
          .oneOf(
            [
              UserRoleEnum.Agent,
              UserRoleEnum.FieldCoordinator,
              UserRoleEnum.Driver,
              UserRoleEnum.Farmer,
              UserRoleEnum.Harvester,
            ],
            'Invalid role',
          )
          .required('Role is required'),
        maxPointUsage: Yup.number().min(0, 'Min point usage is 0').required('Masukkan point usage'),
      }),
    )
    .required('RolePointUsageItems is required'),
})

export const validationSchemaFormJobVacancy = Yup.object({
  jobName: Yup.string().required('Isi Nama Pekejaan').max(255, 'Maksimal 255 karakter'),
  quota: Yup.number()
    .required('Masukkan Jumlah Pekerja')
    .min(1, 'Masukkan Jumlah Pekerja')
    .max(999, 'Maksimal 3 digit'),
  areaId: Yup.string().required('Pilih Lokasi Lahan sesuai Kecamatan'),
  wage: Yup.object().shape({
    minimum: Yup.number().required('Masukkan Gaji Minimum').min(1, 'Masukkan Gaji Minimum'),
    maximum: Yup.number().required('Masukkan Gaji Maksimum').min(1, 'Masukkan Gaji Maksimum'),
    unit: Yup.string().required('Pilih Satuan Gaji'),
  }),
  terrain: Yup.object().shape({
    soilType: Yup.string().required('Pilih Jenis Tanah'),
  }),
})
